export default __webpack_public_path__ + "static/media/amaliyot_otash_tartibi.5810ef77.pdf";